import Typography, { TypographyProps } from '@mui/material/Typography';
import { DateTime } from 'luxon';
import * as React from 'react';
import { DateTimeFormat } from '../../../sic-lib/enums/DateTimeFormat';

type Props = Omit<TypographyProps, 'children'> & {
    dateText: DateTime | string;
    formatPreset?: DateTimeFormat;
};

export default function DisplayDateTime({ dateText, formatPreset, ...props }: Props) {
    //fix default 'p' tag by Typography (stupid DOM validation "p can't contain child p tags")
    const variantMapping = props.variantMapping || { body1: 'span' };

    const formattedDate = React.useMemo(() => {
        const dt = typeof dateText == 'string' ? DateTime.fromISO(dateText) : dateText;

        let formatted;

        if (formatPreset) {
            formatted = dt.toLocaleString(DateTime[formatPreset]);
        } else {
            formatted = dt.toLocaleString(DateTime.DATE_MED);
        }

        return formatted;
    }, [dateText]);

    return (
        <Typography {...props} variantMapping={variantMapping}>
            {formattedDate}
        </Typography>
    );
}
